module.exports = __webpack_public_path__ + "img/icon1.900d6948.png";